(() => {
  const drawer = document.querySelector('[data-mobile-menu]');
  if (!drawer) return;

  // ── Focus trap (fallback if drawer-focus.js not loaded) ─────────────
  const FOCUSABLE_SELECTOR =
    'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),summary,[tabindex]:not([tabindex="-1"])';
  const focusState = { last: null, keyHandler: null };

  const getFocusable = () =>
    Array.from(drawer.querySelectorAll(FOCUSABLE_SELECTOR)).filter((el) => {
      if (el.hidden || el.closest('[hidden]') || el.closest('[inert]')) return false;
      const s = window.getComputedStyle(el);
      return s.display !== 'none' && s.visibility !== 'hidden';
    });

  const setBackgroundInert = (on) => {
    Array.from(document.body.children).forEach((node) => {
      if (node === drawer || node.contains(drawer)) return;
      if (node.tagName === 'SCRIPT' || node.tagName === 'STYLE') return;
      if (on) {
        if (!node.hasAttribute('inert')) {
          node.setAttribute('inert', '');
          node.dataset.mmInertApplied = '1';
        }
      } else if (node.dataset.mmInertApplied === '1') {
        node.removeAttribute('inert');
        delete node.dataset.mmInertApplied;
      }
    });
  };

  const trapKeydown = (e) => {
    if (e.key !== 'Tab') return;
    const f = getFocusable();
    if (f.length === 0) {
      e.preventDefault();
      return;
    }
    const first = f[0];
    const last = f[f.length - 1];
    if (e.shiftKey ? document.activeElement === first || !drawer.contains(document.activeElement) : document.activeElement === last) {
      e.preventDefault();
      (e.shiftKey ? last : first).focus();
    }
  };

  const activateFocus = () => {
    if (window.DrawerFocus) return;
    focusState.last = document.activeElement;
    setBackgroundInert(true);
    focusState.keyHandler = trapKeydown;
    drawer.addEventListener('keydown', focusState.keyHandler);
    requestAnimationFrame(() => {
      const closeBtn = drawer.querySelector('[data-mobile-menu-close]:not(.mobile-menu__overlay)');
      const target = closeBtn || getFocusable()[0];
      target?.focus({ preventScroll: false });
    });
  };
  const deactivateFocus = () => {
    if (window.DrawerFocus) return;
    setBackgroundInert(false);
    if (focusState.keyHandler) {
      drawer.removeEventListener('keydown', focusState.keyHandler);
      focusState.keyHandler = null;
    }
    if (focusState.last && document.contains(focusState.last)) {
      try { focusState.last.focus(); } catch { /* noop */ }
    }
    focusState.last = null;
  };

  const open = () => {
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('mobile-menu-open');
    document.querySelectorAll('[data-mobile-menu-toggle]').forEach((btn) => {
      btn.setAttribute('aria-expanded', 'true');
    });
    activateFocus();
  };
  const close = () => {
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('mobile-menu-open');
    document.querySelectorAll('[data-mobile-menu-toggle]').forEach((btn) => {
      btn.setAttribute('aria-expanded', 'false');
    });
    deactivateFocus();
  };

  document.querySelectorAll('[data-mobile-menu-toggle]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      expanded ? close() : open();
    });
  });

  drawer.querySelectorAll('[data-mobile-menu-close]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      close();
    });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') close();
  });

  // Close drawer when clicking any in-menu link (anchor) so navigation works smoothly
  drawer.querySelectorAll('a[href]').forEach((a) => {
    a.addEventListener('click', () => close());
  });
})();
